import VideoIntroPage from "@/components/Onboarding/GuidedVideo/VideoIntroPage";

function GuidedVideoPage() {
  return <VideoIntroPage />;
}

export default GuidedVideoPage;
